import Component from '../core/Component'
import keycode from 'keycode'
import { enableScroll, disableScroll } from '../services/Scroll'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export const STATES = {
    ACTIVE: 'is-active'
}

export default class PopupNav extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            close: null,
            main: null,
            bg: null,
            bg2: null
        }
    }

    prepare() {
        if (this.ref.close) {
            this.ref.close.addEventListener('click', this.handleCloseClick)
        }
        this.ref.bg.addEventListener('click', this.handleBgClick)
        EventBus.on(EVENTS.SWUP_CLICK_LINK, this.handleSwupClick)
    }

    destroy() {
        this.close()
        EventBus.off(EVENTS.SWUP_CLICK_LINK, this.handleSwupClick)
    }

    handleBgClick = () => {
        this.close()
    }

    handleCloseClick = () => {
        this.close()
    }

    handleSwupClick = () => {
        this.close()
    }

    handleClick(event) {
        if (!this.ref.content.contains(event.target)) {
            event.preventDefault()
            this.close()
        } else if (event.target.closest('a')) {
            this.close()
        }
    }

    handleKeydown = event => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeydown)
        enableScroll()
        EventBus.emit('nav-close')
    }

    open() {
        disableScroll()
        this.element.classList.add(STATES.ACTIVE)
        document.addEventListener('keydown', this.handleKeydown)
        const height = this.ref.main.getBoundingClientRect()?.height ?? 0
        this.ref.bg2.style.height = `${height}px`
        EventBus.emit('nav-open')
    }
}